import { render, staticRenderFns } from "./taskManagement.vue?vue&type=template&id=abf8099a&scoped=true"
import script from "./taskManagement.vue?vue&type=script&lang=js"
export * from "./taskManagement.vue?vue&type=script&lang=js"
import style0 from "./taskManagement.vue?vue&type=style&index=0&id=abf8099a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf8099a",
  null
  
)

export default component.exports